import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';


class Opportunities extends React.Component{
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
    Economic Opportunities
    </Header>
    <Divider/>

    <p>
      Several major research universities in UK and the US have created campus-based venture capital
      programs or investment funds to promote innovation startups and spinouts.
    </p>
    <p>
    There are good deal flows from major prominent research universities such as Oxford, Cambridge,
Imperial, Edinburgh, Harvard, Stanford, MIT, etc. OVC has good access to research
laboratories in the US, UK, and Asia. OVC’s Council of Experts is a hands-on management group that
provides the first tranche of peer review.
    </p>
    <p>
      Innovation and technologies are the new tools to mitigate urbanization problems and to increase
      productivity. Many cities have labeled themselves as smart cities by seeking disruptive technologies
      from academia and introducing them into industries and private enterprises.
    </p>
      </Container>;
  }
}

export default Opportunities;
